import { Routes } from '@angular/router';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { DivineServiceTypeListComponent } from './components/divine-service-type-list/divine-service-type-list.component';
import { DivineServiceTypeEditorComponent } from './components/divine-service-type-editor/divine-service-type-editor.component';
import { MinistryListComponent } from './components/ministry-list/ministry-list.component';
import { MinistryEditorComponent } from './components/ministry-editor/ministry-editor.component';
import { MinistryAppointmentListComponent } from './components/ministry-appointment-list/ministry-appointment-list.component';
import { MinistryAppointmentEditorComponent } from './components/ministry-appointment-editor/ministry-appointment-editor.component';
import { AssignmentListComponent } from './components/assignment-list/assignment-list.component';
import { AssignmentEditorComponent } from './components/assignment-editor/assignment-editor.component';
import { OrganizationUnitEventTypeListComponent } from './components/organization-unit-event-type-list/organization-unit-event-type-list.component';
import { OrganizationUnitEventTypeEditorComponent } from './components/organization-unit-event-type-editor/organization-unit-event-type-editor.component';
import { AreaListComponent } from './components/area-list/area-list.component';
import { ActivityListComponent } from './components/activity-list/activity-list.component';
import { ActivityEditorComponent } from './components/activity-editor/activity-editor.component';
import { PortalMemberImportComponent } from './components/portal-member-import/portal-member-import.component';
import { DeletedMemberListComponent } from './components/deleted-member-list/deleted-member-list.component';
import { PortalImportHistoryComponent } from './components/portal-import-history/portal-import-history.component';
import { PortalImportEquivalencesComponent } from './components/portal-import-equivalences/portal-import-equivalences.component';

export const configurationRoutes: Routes = [
  { path: 'team-tasks', data: { breadcrumb: 'Tareas de equipo' }, loadComponent: () => import('./components/team-tasks-settings/team-tasks-settings.component').then(m => m.TeamTasksSettingsComponent) },
  { path: 'portal-import-history', data: { breadcrumb: 'Historial de importaciones' }, component: PortalImportHistoryComponent },
  { path: 'deleted-members', data: { breadcrumb: 'Todos los miembros' }, component: DeletedMemberListComponent },
  { path: 'portal-member-import', data: { breadcrumb: 'Importar miembros' }, component: PortalMemberImportComponent },
  { path: 'portal-import-equivalences', data: { breadcrumb: 'Equivalencias NAC Portal' }, component: PortalImportEquivalencesComponent },
  {
    path: '',
    component: ConfigurationComponent,
  },
  {
    path: 'divine-service-types',
    data: { breadcrumb: 'Tipos de Servicios Divinos' },
    children: [
      { path: '', component: DivineServiceTypeListComponent },
      { path: 'new', data: { breadcrumb: 'Nuevo Tipo de Servicio' }, component: DivineServiceTypeEditorComponent },
      { path: ':id/edit', data: { breadcrumb: 'Editar Tipo de Servicio' }, component: DivineServiceTypeEditorComponent },
    ]
  },
  {
    path: 'ministries',
    data: { breadcrumb: 'Ministerios' },
    children: [
      { path: '', component: MinistryListComponent },
      { path: 'new', data: { breadcrumb: 'Nuevo Ministerio' }, component: MinistryEditorComponent },
      { path: ':id/edit', data: { breadcrumb: 'Editar Ministerio' }, component: MinistryEditorComponent },
    ]
  },
  {
    path: 'ministry-appointments',
    data: { breadcrumb: 'Encargos Ministeriales' },
    children: [
      { path: '', component: MinistryAppointmentListComponent },
      { path: 'new', data: { breadcrumb: 'Nuevo Encargo' }, component: MinistryAppointmentEditorComponent },
      { path: ':id/edit', data: { breadcrumb: 'Editar Encargo' }, component: MinistryAppointmentEditorComponent },
    ]
  },
  {
    path: 'assignments',
    data: { breadcrumb: 'Nombramientos' },
    children: [
      { path: '', component: AssignmentListComponent },
      { path: 'new', data: { breadcrumb: 'Nuevo Nombramiento' }, component: AssignmentEditorComponent },
      { path: ':id/edit', data: { breadcrumb: 'Editar Nombramiento' }, component: AssignmentEditorComponent },
    ]
  },
  {
    path: 'community-event-types',
    data: { breadcrumb: 'Tipos de eventos de comunidades' },
    children: [
      { path: '', component: OrganizationUnitEventTypeListComponent },
      { path: 'new', data: { breadcrumb: 'Nuevo tipo de evento' }, component: OrganizationUnitEventTypeEditorComponent },
      { path: ':id/edit', data: { breadcrumb: 'Editar tipo de evento' }, component: OrganizationUnitEventTypeEditorComponent },
    ]
  },
  {
    path: 'areas',
    data: { breadcrumb: 'Áreas' },
    children: [
      { path: '', component: AreaListComponent },
    ]
  },
  {
    path: 'activities',
    data: { breadcrumb: 'Colaboraciones' },
    children: [
      { path: '', component: ActivityListComponent },
      { path: 'new', data: { breadcrumb: 'Nueva colaboración' }, component: ActivityEditorComponent },
      { path: ':id/edit', data: { breadcrumb: 'Editar colaboración' }, component: ActivityEditorComponent },
    ]
  },
];
